export const PAGES = {
  ROOT: '/',
  LANDING: '/landing',
  ENTRY: '/entry',
  SUBMISSION: '/submission',
} as const;

export const ENDPOINTS = {
  // Local API
  GEOIP: '/geoip',
  ENTRY: '/entry',
} as const;

export const STORAGE = {
  DEFAULT: {
    ENTRY_EMAIL: 'campaign-starter-kit-default-email',
  },
};

export const CONTENT = {
  LANDING: 'csk_home_page',
  SUBMISSION: 'csk_submission_page',
} as const;

export const DEFAULT_LOCALE = 'en';

export const SHORT_LOCALES = ['en', 'es'] as const;

export const LOCALES = [
  {
    code: 'en',
    name: 'English',
  },
  {
    code: 'es',
    name: 'Español',
  },
] as const;

export const ORIGIN = {
  local: {
    en: 'http://localhost:3001/en',
    es: 'http://localhost:3001/es',
  },
  test: {
    en: 'http://localhost:3001/en',
    es: 'http://localhost:3001/es',
  },
  development: {
    en: 'https://campaign-starter-kit-eks.dev.csm.reviews/en',
    es: 'https://campaign-starter-kit-eks.dev.csm.reviews/es',
  },
  staging: {
    en: 'https://campaign-starter-kit-eks.stg.csm.reviews/en',
    es: 'https://campaign-starter-kit-eks.stg.csm.reviews/es',
  },
  production: {
    en: 'https://campaign-starter-kit.prod.csm.reviews/en',
    es: 'https://campaign-starter-kit.prod.csm.reviews/es',
  },
} as const;

export const CARTO = {
  // Public tile-service key — safe to expose client-side. Restrict allowed
  // domains in the CARTO dashboard; that's the real access control, not
  // secrecy of the key. Removes attribution requirement and raises rate limits.
  // prettier-ignore
  API_KEY: 'cb1_2s3c_1_ce390910fc6557e3a18d5849',
} as const;

export const SALESFORCE = {
  REST_DOMAIN: process.env.SALESFORCE_REST_ENDPOINT,
  AUTH_DOMAIN: process.env.SALESFORCE_AUTH_ENDPOINT,
  CLIENT_ID: process.env.SALESFORCE_CLIENT_ID,
  ACCOUNT_ID: process.env.SALESFORCE_ACCOUNT_ID,
  CLIENT_SECRET: process.env.SALESFORCE_CLIENT_SECRET,
  MAX_EXPIRATION_DIFF_MS: 10000, // ms - 10s
  // Async DE upsert — SFMC resolves the row against the DE's own primary keys,
  // so the payload is a flat field map (no `keys`/`values` split, no need to
  // know the PK column names). Returns 202 Accepted.
  UPSERT_URL: `${process.env.SALESFORCE_REST_ENDPOINT}/data/v1/async/dataextensions/key:<key>/rows`,
  // Data-extension external keys. Leave blank in envs without a Salesforce
  // integration (local/test) — the entry action skips the upsert when unset.
  DE: {
    MASTER: process.env.SALESFORCE_DE_MASTER,
    CAMPAIGN: process.env.SALESFORCE_DE_CAMPAIGN,
  },
} as const;

/**
 * Campaign identifiers. Each key maps to a `Campaign.name` row in the database
 * and is used as the prefix for that campaign's Salesforce data-extension fields.
 */
export const CAMPAIGN = {
  DEFAULT: 'campaign-starter-kit',
  HUB: 'american_eagle_lamine_yamal',
} as const;

export const REQUIRED_QUERY_PARAMS = [
  // 'utm_source',
  // 'utm_medium',
  // 'utm_campaign',
  // 'utm_term',
  // 'utm_content',
] as const;

export const BREAKPOINTS = {
  SM: 431,
  MD: 541,
  LG: 1024,
  XL: 1440,
  XXL: 1920,
  XXXL: 2560,
};

export const SSG_REVALIDATE_RATE_SEC = 10;
export const GEO_FALLBACK_CLIENT_IP = '0.0.0.0';
export const SENTRY_ENVIRONMENT = process.env.ENVIRONMENT ?? process.env.NEXT_PUBLIC_ENVIRONMENT;
// prettier-ignore
export const SENTRY_DSN = 'https://57fd13775f909d99c8251cb8bc5c3cf0@o4506433853849600.ingest.us.sentry.io/4506472334032896';
export const SENTRY_TRACE_SAMPLE_RATE = 0.1;
export const SENTRY_REPLAY_SAMPLE_RATE = 0.1;
export const SENTRY_ERROR_SAMPLE_RATE = 1.0;
export const RESIZE_POLL_RATE_MS = 200;
export const FALLBACK_ALT = 'No descriptive information provided about the image.';
// prettier-ignore
export const FALLBACK_IMAGE = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
